/**
 * Region utility functions
 * Separated from utils.ts to avoid circular dependencies with metrics
 */

export const getRegionRealm = (): string => {
    const region = getValidRegion()
    return region + "Amazon"
}

export const getValidRegion = (): string => {
    let Regions = ['NA','EU','FE','CN'];

    const regionParam = getQueryParamsMap(window.location.search).region;
    // We can also emit metrics when wrong region is provided in the URL and have it emitted
    // Currently when wrong region is provided in the URL params, it will be defaulted to NA region
    const region = Regions.includes(regionParam) ? regionParam : 'NA';
    return region;
}

export const getQueryParamsMap = (pathSearch: string) => {
    const params: any = new Proxy(new URLSearchParams(pathSearch), {
        get: (queryParams, prop: any) => queryParams.get(prop)
    });

    return params
}
